import { LocalizationProvider, StaticDatePicker } from '@mui/lab'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import { TextField } from '@mui/material'
import { styled } from '@mui/material/styles'
import { forwardRef, useMemo } from 'react'
import { useNow } from '../../../hooks/useNow'
import { getMinimumAllowedDate } from '../../../util/getMinimumAllowedDate'
import deDELocale from 'date-fns/locale/de'
import enUSLocale from 'date-fns/locale/en-US'
import i18next from 'i18next'

type NullableDate = Date | null

interface Props {
  customerTimeZone: string
  name: string
  onChange: (date: NullableDate) => void
  onMonthChange: (date: NullableDate) => void
  value: NullableDate
  maxDate?: Date
}

const CustomDatePickerWidth = styled('div')`
  > div > div > div > div > div:first-of-type {
    // Remove calendar header top margin. Gross, I know
    margin-top: 0;
  }

  > div > div > div {
    width: 100%;
  }
`

const getLocale = (locale: string) => {
  const language = new Intl.Locale(locale || 'en').language

  switch (language) {
    case 'de':
      return deDELocale
    default:
      return enUSLocale
  }
}

const Calendar = forwardRef(({ customerTimeZone, name, value, ...props }: Props, ref) => {
  const { data: now = new Date() } = useNow()

  const locale = useMemo(() => {
    return getLocale(i18next.language)
  }, [i18next.language])

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={locale}>
      <CustomDatePickerWidth
        sx={{
          p: 0,
          pt: {
            md: 0,
            xs: 2.5,
          },
        }}
      >
        <StaticDatePicker
          {...props}
          displayStaticWrapperAs="desktop"
          minDate={getMinimumAllowedDate(now, customerTimeZone)}
          name={name}
          orientation="landscape"
          // @ts-expect-error Ref type mismatch (something to do with generics)
          ref={ref}
          renderInput={(params) => <TextField {...params} />}
          value={value}
          views={['day']}
        />
      </CustomDatePickerWidth>
    </LocalizationProvider>
  )
})

export { Calendar }
